import type * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';

export type FloatKind = 'coins' | 'item' | 'xp' | 'rare' | 'info';

const LIFETIME = 1.6;

interface Floater {
  object: CSS2DObject;
  age: number;
}

/** "+12 🪙" style labels that drift upwards from a point in the world. */
export class FloatingText {
  private readonly floaters: Floater[] = [];

  constructor(private readonly scene: THREE.Scene) {}

  spawn(position: THREE.Vector3, text: string, kind: FloatKind = 'item', delay = 0): void {
    const element = document.createElement('div');
    element.className = `float-text float-${kind}`;
    element.textContent = text;
    element.style.animationDelay = `${delay}s`;
    const object = new CSS2DObject(element);
    object.position.copy(position);
    this.scene.add(object);
    this.floaters.push({ object, age: -delay });
  }

  update(dt: number): void {
    for (let i = this.floaters.length - 1; i >= 0; i--) {
      const floater = this.floaters[i]!;
      floater.age += dt;
      if (floater.age > 0) floater.object.position.y += dt * 0.9;
      if (floater.age > LIFETIME) {
        floater.object.element.remove();
        floater.object.removeFromParent();
        this.floaters.splice(i, 1);
      }
    }
  }
}
